import React from 'react'
import ProgressStore from './ProgressStore/ProgressStore'
import StepsStore from './StepsStore/StepsStore'
import ChangeInputValue from './StepsStore/modules/changeValue'
import NextStep from './StepsStore/modules/nextStep'
import RedirectButton from './StepsStore/modules/redirectButton'
import ProgressBar from './ProgressBar/ProgressBar'

interface BaseConfigs {
  stepsStoreConfig: any
  stepsStoreApi: any
}

export class RootStore {
  ProgressStore: ProgressStore
  StepsStore: StepsStore
  NextStep: NextStep
  ChangeInputValue: ChangeInputValue
  RedirectButton: RedirectButton
  ProgressBar: ProgressBar

  constructor() {
    this.ProgressStore = new ProgressStore(this)
    this.StepsStore = new StepsStore(this)
    this.NextStep = new NextStep(this)
    this.ChangeInputValue = new ChangeInputValue(this)
    this.RedirectButton = new RedirectButton(this)
    this.ProgressBar = new ProgressBar(this)
  }

  setConfig({
    stepsStoreConfig,
    stepsStoreApi
  }: BaseConfigs) {
    this.StepsStore.setConfigs({
      stepsStoreConfig,
      stepsStoreApi
    })
  }
}

export const Store = new RootStore()
export const StoresContext = React.createContext(Store)

export const useStore = () => React.useContext(StoresContext)